<template>
  <div class="personal-information">
    <h1>
      <i class="iconfont icon-arrow_a back" @click="router.back()"></i>
      个人信息
    </h1>

    <el-card v-if="manager" shadow="never">
      <template #header>
        <span class="card-title">账号信息</span>
      </template>
      <el-descriptions :column="1" label-width="120px" border>
        <el-descriptions-item label="姓名">
          {{ manager.name || "—" }}
        </el-descriptions-item>
        <el-descriptions-item label="用户名">
          {{ manager.username || "—" }}
        </el-descriptions-item>
        <el-descriptions-item label="邮箱">
          {{ manager.email || "—" }}
        </el-descriptions-item>
        <el-descriptions-item label="账号类型">
          管理端账号（开发公司内部）
        </el-descriptions-item>
      </el-descriptions>

      <el-alert
        type="info"
        :closable="false"
        show-icon
        style="margin-top: 16px"
        title="如需修改密码，请在退出登录后通过登录页的「忘记密码」流程（邮箱验证）重置。"
      />
    </el-card>

    <el-card v-else shadow="never">
      <el-skeleton :rows="4" />
    </el-card>
  </div>
</template>

<script lang="ts" setup>
// 管理端个人信息页（只读展示当前登录的 manager 账号信息）
// 数据来源：登录后 /verify_token 写入 store 的 managerInfo（id/name/username/email）
import store from "@/store";
import { computed } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const manager = computed(() => store.getters["auth/managerInfo"]);
</script>

<style scoped>
.personal-information {
  padding: 16px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
}
h1 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  margin: 0 0 16px;
}
.back {
  cursor: pointer;
  font-size: 18px;
  color: #909399;
}
.back:hover {
  color: #409eff;
}
.card-title {
  font-weight: 600;
}
</style>
